export default __webpack_public_path__ + "static/stock-d7f7c6e412111c3e2ca76876befa2a3e.png";